import React from "react";
import { wire } from "react-hot-wire";

import { WithTranslation, withTranslation } from "react-i18next";

import { Table } from "components/common/table/Table";
import { Query } from "components/common/table/types";

import { PrizeService } from "services/prize/Prize.service";

function PrizeOrderList({
  prizeService,
  t
}: {
  prizeService: PrizeService;
} & WithTranslation) {
  const i18nKey = "prize.order.list";

  return (
    <div className="m-3">
      <Table
        title={t(`${i18nKey}.title`)}
        dataFetcher={(query: Query) => prizeService.orderList({ query })}
        options={{
          search: true,
          pagination: true,
          sortingMode: "single"
        }}
        columns={[
          {
            field: "id",
            title: t(`${i18nKey}.column.id`),
            order: "desc"
          },
          {
            field: "orderDate",
            title: t(`${i18nKey}.column.orderDate`)
          },
          {
            field: "application",
            title: t(`${i18nKey}.column.application`)
          },
          {
            field: "itemName",
            title: t(`${i18nKey}.column.itemName`),
            sorting: false
          },
          {
            field: "budgetValue",
            title: t(`${i18nKey}.column.budgetValue`)
          },
          {
            field: "deliveryAddress",
            title: t(`${i18nKey}.column.deliveryAddress`),
            sorting: false
          },
          {
            field: "deliveryEmail",
            title: t(`${i18nKey}.column.deliveryEmail`),
            sorting: false
          },
          {
            field: "deliveryPhone",
            title: t(`${i18nKey}.column.deliveryPhone`),
            sorting: false
          }
        ]}
      />
    </div>
  );
}

export default wire(["prizeService"], withTranslation()(PrizeOrderList));
